// extracted by mini-css-extract-plugin
export var centerText = "_5w-8";
export var container = "_5w-0";
export var doughnutContainer = "_5w-7";
export var legend = "_5w-a";
export var legendItemColorDisplay = "_5w-b";
export var legendItemLabel = "_5w-d";
export var legendItemValue = "_5w-c";
export var lg = "_5w-5";
export var maxWidth = "_5w-9";
export var md = "_5w-4";
export var responsive = "_5w-6";
export var sm = "_5w-3";
export var xs = "_5w-2";
export var xxs = "_5w-1";